import { useQuery } from '@tanstack/react-query';

import type { BranchScope } from '../data/fetchers';
import { listBranches } from '../data/fetchers';
import { useSession } from '../stores/session';
import { useUi } from '../stores/ui';
import { visibleBranchIds } from './permissions';

/** Branch scope for report queries + a `ready` flag (branches loaded & user present). */
export function useBranchScope(): { scope: BranchScope; ready: boolean } {
  const branchId = useUi((s) => s.branchId);
  const user = useSession((s) => s.user);
  const { data: branches } = useQuery({
    queryKey: ['branches'],
    queryFn: listBranches,
  });
  const ready = !!user && !!branches;
  const allowedBranchIds =
    user && branches
      ? visibleBranchIds(
          user,
          branches.map((b) => b.id),
        )
      : [];
  return { scope: { branchId, allowedBranchIds }, ready };
}
